import { CityRO } from '@routellers/types/dist/city/city.ro';
import { UpdateCityDto } from '@routellers/types/dist/city/update-city.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    id: number;
    data: UpdateCityDto;
};

type ResponseData = CityRO;

export const update: ApiMethodDeclaration<ParamsData, ResponseData> = ({ id, data }) => ({
    url: `/cities/${id}`,
    method: 'PATCH',
    data,
});
